import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import { installAppViewportHeightSync } from './viewport'
import './styles.css'

if (typeof window !== 'undefined') {
  installAppViewportHeightSync()

  window.__cabinetsInstallPrompt = null

  const preventStandaloneZoomGesture = (event) => {
    event.preventDefault()
  }

  window.addEventListener('beforeinstallprompt', (event) => {
    event.preventDefault()
    window.__cabinetsInstallPrompt = event
    window.dispatchEvent(new Event('cabinets-install-prompt-ready'))
  })

  window.addEventListener('appinstalled', () => {
    window.__cabinetsInstallPrompt = null
    window.dispatchEvent(new Event('cabinets-app-installed'))
  })
  window.addEventListener('gesturestart', preventStandaloneZoomGesture, { passive: false })
  window.addEventListener('gesturechange', preventStandaloneZoomGesture, { passive: false })
}

if (import.meta.env.DEV && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.getRegistrations()
      .then((registrations) => Promise.all(registrations.map((registration) => registration.unregister().catch(() => null))))
      .catch(() => null)

    if ('caches' in window) {
      caches.keys()
        .then((keys) => Promise.all(keys.map((key) => caches.delete(key).catch(() => false))))
        .catch(() => null)
    }
  })
}

if (import.meta.env.PROD && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('./sw.js').catch(() => {})
  })
}

ReactDOM.createRoot(document.getElementById('root')).render(
  <App />
)
